import React, { useEffect, useRef } from 'react';
import { Chart, CategoryScale, LinearScale, BarController, BarElement, LineController, LineElement, PointElement } from 'chart.js';

Chart.register(CategoryScale, LinearScale, BarController, BarElement, LineController, LineElement, PointElement);

const Barchart = ({labels, data}) =>
{
	const chartRef = useRef(null);
	let chartInstance = null;

	useEffect(() => {
		CreateChart();
		return () => {
			if (chartInstance)
			{
				chartInstance.destroy();
			}
		};
	// eslint-disable-next-line
	}, []);

	const CreateChart = () =>
	{
		let delayed;
		const ctx = chartRef.current.getContext('2d');
		chartInstance = new Chart(ctx, {
			type: 'bar',
			data: {
				labels: labels,
				datasets: [{
					data: data,
					backgroundColor: [
						'rgba(255, 99, 132, 0.2)',
						'rgba(54, 162, 235, 0.2)',
						'rgba(255, 206, 86, 0.2)',
						'rgba(75, 192, 192, 0.2)',
						'rgba(153, 102, 255, 0.2)',
						'rgba(255, 159, 64, 0.2)'
					],
					borderColor: [
						'rgba(255, 99, 132, 1)',
						'rgba(54, 162, 235, 1)',
						'rgba(255, 206, 86, 1)',
						'rgba(75, 192, 192, 1)',
						'rgba(153, 102, 255, 1)',
						'rgba(255, 159, 64, 1)'
					],
					borderRadius: 7,
					borderWidth: 1,
					tension: 0.4,
				}]
				},
			options: {
				responsive: true,
				animation: {
					onComplete: () => {
					  delayed = true;
					},
					delay: (context) => {
						let delay = 0;
						if (context.type === 'data' && context.mode === 'default' && !delayed)
						{
							delay = context.dataIndex * 500 + context.datasetIndex * 100;
						}
						return delay;
					},
				  },
				scales: {
					y:{
						beginAtZero: true,
						ticks: {
							precision:0
						}
					},
					x:{
						ticks: {
							font: {
								size: 10,
								family:'IranYekan'
							}
						},
					}
				}
			}
		});
	};
	return <canvas ref={chartRef} />;
};

export default Barchart;